import { create } from 'zustand'

let customFieldStates = []
export const useCustomFieldStates = create((set) => ({
  customFieldStates: customFieldStates,
  setCustomFieldStates: (payload = {}) => {
    set((state) => ({
      customFieldStates: {
        ...state.customFieldStates,
        ...payload,
      },
    }))
  },
}))
